import moduleStyles from "components/module/styles.module.css";

import React, { useEffect, useState, use, useImperativeHandle, Ref } from 'react';
import CompensationApiRepository from 'repositories/api/CompensationApiRepository';
import { IconPicker } from "components/layout/icons/IconPicker";
import parse from 'html-react-parser';
import Spacer from "components/layout/Spacer";
import { addHtmlToElemById } from "components/helpers/ElementHelpers";
import { ModuleOnline } from "components/module/ModuleOnline";
import { ModuleWithData } from "components/module/ModuleWithData";
import { ModuleProps } from "components/props/ModuleProps";
import { useNavigate } from "react-router";
import { Module } from "./Module";

interface PromiseProps {
    correctionRequiredCount: number,
}

const DefaultPromiseProps: PromiseProps = {
    correctionRequiredCount: 0,
}

interface DashboardProps {
    refresh: boolean
}

export const Dashboard = ({ refresh }: DashboardProps) => {

    const navigate = useNavigate();
    const [dataPromise, setDataPromise] = useState<null | Promise<PromiseProps>>(null);

    const updateMenuItem = (count = 0) => {
        addHtmlToElemById("MenuItemDescriptionCompensation", (count > 0) ? `&nbsp;<sup>${count}</sup>` : '');
    }

    const fetchOnline = async () => {
        const response = await CompensationApiRepository.getPilotCompensations()
        const data = response instanceof Response ? await response.json() : [];

        const compensations = data.filter((comp) => comp.isCorrectionRequired);
        updateMenuItem(compensations.length);

        return {
            correctionRequiredCount: compensations.length
        }
    }

    const fetchData = (): Promise<PromiseProps> => {
        if (navigator.onLine) {
            return fetchOnline();
        } else {
            return new Promise<PromiseProps>((resolve) => resolve(DefaultPromiseProps));
        }
    }

    const onClick = () => {
        navigate(Module.url);
    }

    useEffect(() => {
        const promise = fetchData();
        setDataPromise(promise);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if(!refresh) return;
        setDataPromise(fetchData());
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [refresh]);

    return (
        <ModuleWithData
            module={Module}
            dataPromise={dataPromise}
            errorText="Kunne ikke hente tillegg.">
            <ModuleCompensationContent
                dataPromise={dataPromise}
                onClick={onClick} />
        </ModuleWithData>
    )
}

interface ModuleCompensationContentProps {
    dataPromise: Promise<PromiseProps>,
    onClick: (module: ModuleProps) => void;
}
export const ModuleCompensationContent = ({
    dataPromise,
    onClick
}: ModuleCompensationContentProps) => {

    const data = use<PromiseProps>(dataPromise);

    return (
        data &&
            <ModuleOnline module={Module}>
                <div
                    className={moduleStyles.bar}
                    style={{ backgroundColor: (data.correctionRequiredCount > 0) ? "var(--home-warning-bg)" : "var(--home-default-bg)" }}
                    onClick={onClick}>
                    <div className={moduleStyles.barContent}>
                        <div>
                            {parse(Module.text)}
                            {
                                (data.correctionRequiredCount > 0) &&
                                <>
                                    <Spacer height={5} />
                                    <div>
                                        Du har {data.correctionRequiredCount} tillegg som krever korrigering
                                    </div>
                                </>
                            }
                        </div>
                        <div><IconPicker icon={Module.icon} size={24} /></div>
                    </div>
                </div>
            </ModuleOnline>
    )
}
